module.exports = __webpack_public_path__ + "img/instagram.f6bfe8eb.svg";